import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, InjectionToken, NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { SvgIconService } from '@app/core/services/svg-icon.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoggerModule } from 'ngx-logger';

// Ngx-bootstrap
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale } from 'ngx-bootstrap/locale';
defineLocale('de', deLocale);

// Dayjs
import * as dayjs from 'dayjs';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as localeData from 'dayjs/plugin/localeData';
import * as customParseFormat from 'dayjs/plugin/customParseFormat'; // Needed to parse time (without date --> HH:mm)
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { environment } from 'src/environments/environment';
import {LoginComponent} from '@app/login/login/login.component';
import { TokenLoginComponent } from './login/token-login/token-login.component';
import { from, Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { GoogleMapsModule } from '@angular/google-maps';
import { UrgentNoticeComponent } from './urgent-notice/urgent-notice/urgent-notice.component';
import { NotificationOverviewComponent } from './notification-overview/notification-overview/notification-overview.component';
import { WhatsnewComponent } from './whatsnew/whatsnew/whatsnew.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/locales/locale-', '.json?v=' + environment.version);
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TokenLoginComponent
  ],
  imports: [
    BrowserModule,
    GoogleMapsModule,
    BrowserAnimationsModule, // Required for ngx-bootstrap (and in genaral for animations)
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    LoggerModule.forRoot({
      level: environment.logLevel,
      // Shows the name of the file which caused the log entry only in devPage mode
      enableSourceMaps: !environment.production
    }),
    // ngx-bootstrap
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ProgressbarModule.forRoot(),
    // Modules from this project
    AppRoutingModule,
    CoreModule,
    SharedModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (icons: SvgIconService) => () => icons.load(),
      deps: [SvgIconService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

